import { createRouter, createWebHistory } from "vue-router";
import { clearStoredSession, hasValidSession } from "./publicjs/authSession";

const routes = [
  {
    path: "/:pathMatch(.*)",
    component: () => import("./views/NotFound.vue"),
  },
  {
    path: "/",
    name: "HomePage",
    component: () => import("./views/Home.vue"),
    meta: {
      title: "Home ",
      requiresAuth: true,
    },
  },
  {
    path: "/seguimiento/:businessSlug/:slug",
    name: "WorkshopPublicTracking",
    component: () => import("./views/Workshop/WorkshopPublicTracking.vue"),
    meta: {
      title: "Seguimiento de servicio técnico ",
      publicLayout: true,
    },
  },
  {
    path: "/taller/seguimiento/:slug",
    name: "WorkshopPublicTrackingLegacy",
    component: () => import("./views/Workshop/WorkshopPublicTracking.vue"),
    meta: {
      title: "Seguimiento de servicio técnico ",
      publicLayout: true,
    },
  },
  {
    path: "/modulos-del-sistema",
    name: "SystemModules",
    component: () => import("./views/SystemModules/SystemModules.vue"),
    meta: {
      title: "Módulos del sistema ",
      requiresAuth: true,
    },
  },
  {
    path: "/sub-modulos",
    name: "SystemSubModules",
    component: () => import("./views/SystemModules/SystemSubModules.vue"),
    meta: {
      title: "Submódulos del Sistema ",
      requiresAuth: true,
    },
  },
  {
    path: "/empresa",
    name: "CompanyConfigurations",
    component: () => import("./views/Company/Company.vue"),
    meta: {
      title: "Empresa ",
      requiresAuth: true,
    },
  },
  {
    path: "/sucursal",
    name: "StoresConfigurations",
    component: () => import("./views/Company/Stores/Stores.vue"),
    meta: {
      title: "Sucursal ",
      requiresAuth: true,
    },
  },
  {
    path: "/tipo-de-documentos",
    name: "TypeDocuments",
    component: () => import("./views/ConfigurationModules/TypeDocuments/TypeDocuments.vue"),
    meta: {
      title: "Tipo de documentos ",
      requiresAuth: true,
    },
  },
  {
    path: "/tipo-de-usuarios",
    name: "TypeOfUsers",
    component: () => import("./views/Users/TypeOfUsers/TypeOfUsers.vue"),
    meta: {
      title: "Tipo de Usuarios ",
      requiresAuth: true,
    },
  },
  {
    path: "/usuarios",
    name: "MainUser",
    component: () => import("./views/Users/Main/MainUsers.vue"),
    meta: {
      title: "Usuarios ",
      requiresAuth: true,
    },
  },
  {
    path: "/turnos",
    name: "MainTurn",
    component: () => import("./views/Users/Turns/Turns.vue"),
    meta: {
      title: "Turnos ",
      requiresAuth: true,
    },
  },
  {
    path: "/horarios",
    name: "WorkSchedules",
    component: () => import("./views/Users/WorkSchedules/WorkSchedules.vue"),
    meta: {
      title: "Horarios ",
      requiresAuth: true,
    },
  },
  {
    path: "/accesos",
    name: "AccessMain",
    component: () => import("./views/Users/Access/Access.vue"),
    meta: {
      title: "Acessos De Módulo Del Sistema ",
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/Login.vue"),
    meta: {
      title: "Inicio de sesión ",
    },
  },
  {
    path: "/perfil",
    name: "profile",
    component: () => import("./views/Users/Main/ProfileUser.vue"),
    meta: {
      title: "Mi perfil ",
      requiresAuth: true,
    },
  },
  {
    path: "/contrataciones",
    name: "ConfigureUsersPayment",
    component: () => import("./views/Users/Payments/UserHiring.vue"),
    meta: {
      title: "Configurar pagos del usuario ",
      requiresAuth: true,
    },
  },
  {
    path: "/tipo-de-comprobantes",
    name: "TypeOfVouchers",
    component: () => import("./views/ConfigurationModules/TypeOfVouchers/TypeOfVouchers.vue"),
    meta: {
      title: "Tipo de comprobantes ",
      requiresAuth: true,
    },
  },
  {
    path: "/delivery-app",
    name: "DeliveryApp",
    component: () => import("./views/ConfigurationModules/DeliveryApp/DeliveryApp.vue"),
    meta: {
      title: "App de delivery ",
      requiresAuth: true,
    },
  },
  {
    path: "/comprobantes",
    name: "Vouchers",
    component: () => import("./views/ConfigurationModules/Vouchers/Vouchers.vue"),
    meta: {
      title: "Comprobantes ",
      requiresAuth: true,
    },
  },
  {
    path: "/iva",
    name: "iva",
    component: () => import("./views/ConfigurationModules/Iva/Iva.vue"),
    meta: {
      title: "Iva ",
      requiresAuth: true,
    },
  },
  {
    path: "/descuento-global",
    name: "DiscountGlobal",
    component: () => import("./views/ConfigurationModules/DiscountGlobal/DiscountGlobal.vue"),
    meta: {
      title: "Descuento global ",
      requiresAuth: true,
    },
  },
  {
    path: "/divisas",
    name: "Currencys",
    component: () => import("./views/ConfigurationModules/Currencys/Currencys.vue"),
    meta: {
      title: "Divisas ",
      requiresAuth: true,
    },
  },
  {
    path: "/configuracion-de-impresion",
    name: "ConfigureVouchersPrint",
    component: () => import("./views/ConfigurationModules/ConfigureVouchersPrint/ConfigureVouchersPrint.vue"),
    meta: {
      title: "Configuracion de impresion de comprobantes ",
      requiresAuth: true,
    },
  },
  {
    path: "/correos",
    name: "Emails",
    component: () => import("./views/ConfigurationModules/Emails/Emails.vue"),
    meta: {
      title: "Configuracion correos ",
      requiresAuth: true,
    },
  },
  {
    path: "/comisiones",
    name: "ConfigCommissions",
    component: () => import("./views/ConfigurationModules/Commissions/Commissions.vue"),
    meta: {
      title: "Configuracion comisiones ",
      requiresAuth: true,
    },
  },
  {
    path: "/clientes",
    name: "SettingCustomers",
    component: () => import("./views/Customers/Customers.vue"),
    meta: {
      title: "Clientes ",
      requiresAuth: true,
    },
  },
  {
    path: "/aseguradoras",
    name: "InsuranceCompanies",
    component: () => import("./views/InsuranceCompanies/InsuranceCompanies.vue"),
    meta: {
      title: "Aseguradoras ",
      requiresAuth: true,
    },
  },
  {
    path: "/proveedores",
    name: "Suppliers",
    component: () => import("./views/Suppliers/Suppliers.vue"),
    meta: {
      title: "Proveedores ",
      requiresAuth: true,
    },
  },
  {
    path: "/tipo-de-productos",
    name: "TypeOfProducts",
    component: () => import("./views/Store/TypeOfProducts/TypeOfProducts.vue"),
    meta: {
      title: "Tipo de productos ",
      requiresAuth: true,
    },
  },
  {
    path: "/unidad-de-medidas",
    name: "UnitMeasures",
    component: () => import("./views/Store/UnitMeasures/UnitMeasures.vue"),
    meta: {
      title: "Unidad de medidas ",
      requiresAuth: true,
    },
  },
  {
    path: "/productos",
    name: "Products",
    component: () => import("./views/Store/Products/Main/Products.vue"),
    meta: {
      title: "Productos ",
      requiresAuth: true,
    },
  },
  {
    path: "/ofertas",
    name: "ProductOffers",
    component: () => import("./views/Store/ProductOffers/ProductOffers.vue"),
    meta: {
      title: "Oferta ",
      requiresAuth: true,
    },
  },
  {
    path: "/orden-de-compras",
    name: "PurchaseOrder",
    component: () => import("./views/PurchaseOrder/PurchaseOrder.vue"),
    meta: {
      title: "Orden de compras ",
      requiresAuth: true,
    },
  },
  {
    path: "/listado-de-orden-de-compras",
    name: "ListPurchaseOrder",
    component: () => import("./views/PurchaseOrder/ListPurchaseOrder.vue"),
    meta: {
      title: "Listado de orden de compras ",
      requiresAuth: true,
    },
  },
  {
    path: "/compras",
    name: "Shopping",
    component: () => import("./views/Shopping/Shopping.vue"),
    meta: {
      title: "Compras",
      requiresAuth: true,
    },
  },
  {
    path: "/ayuda",
    name: "HelpMe",
    component: () => import("./views/HelpMe/HelpMe.vue"),
    meta: {
      title: "Ayuda sobre el sistema",
      requiresAuth: true,
    },
  },
  {
    path: "/listado-de-compras",
    name: "ListShopping",
    component: () => import("./views/Shopping/ListShopping.vue"),
    meta: {
      title: "Listado de compras",
      requiresAuth: true,
    },
  },
  {
    path: "/compras-externas",
    name: "ExternalShopping",
    component: () => import("./views/Shopping/ExternalShopping.vue"),
    meta: {
      title: "Compras externas",
      requiresAuth: true,
    },
  },
  {
    path: "/kardex",
    name: "KardexData",
    component: () => import("./views/Kardex/Kardex.vue"),
    meta: {
      title: "Kardex ",
      requiresAuth: true,
    },
  },
  {
    path: "/lotes",
    name: "LotsData",
    component: () => import("./views/Store/BatchesOfProducts/Lots.vue"),
    meta: {
      title: "Lotes ",
      requiresAuth: true,
    },
  },
  {
    path: "/nota-de-credito-compras",
    name: "CreditNoteShopping",
    component: () => import("./views/Shopping/CreditNote/CreditNoteShopping.vue"),
    meta: {
      title: "Nota de crédito de compras ",
      requiresAuth: true,
    },
  },
  {
    path: "/cuentas-por-pagar",
    name: "AccountPayable",
    component: () => import("./views/Shopping/AccountsPayable/AccountsPayable.vue"),
    meta: {
      title: "Cuentas por pagar ",
      requiresAuth: true,
    },
  },
  {
    path: "/historial-de-pagos-cuentas-por-pagar",
    name: "ListOfAccountsPayablePayments",
    component: () => import("./views/Shopping/AccountsPayable/ListOfAccountsPayablePayments.vue"),
    meta: {
      title: "Historial de pagos C.P. ",
      requiresAuth: true,
    },
  },
  {
    path: "/desembolsos",
    name: "DisbursementsData",
    component: () => import("./views/Disbursements/Disbursements.vue"),
    meta: {
      title: "Desembolsos o egresos ",
      requiresAuth: true,
    },
  },
  {
    path: "/caja-chica",
    name: "PettyCashView",
    component: () => import("./views/PettyCash/PettyCash.vue"),
    meta: {
      title: "Gestión de caja chica ",
      requiresAuth: true,
    },
  },
  {
    path: "/historial-de-caja-chica",
    name: "PettyCashHistoryView",
    component: () => import("./views/PettyCash/PettyCashHistory.vue"),
    meta: {
      title: "Historial de caja chica ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-caja-chica",
    name: "PettyCashReportView",
    component: () => import("./views/PettyCash/PettyCashReport.vue"),
    meta: {
      title: "Reporte de caja chica ",
      requiresAuth: true,
    },
  },
  {
    path: "/accesos-especificos",
    name: "SystemEspecificAccess",
    component: () => import("./views/SystemModules/SystemEspecificAccess.vue"),
    meta: {
      title: "Accesos específicos del sistema ",
      requiresAuth: true,
    },
  },
  {
    path: "/agentes-del-sistema",
    name: "AgentWorkspace",
    component: () => import("./views/Agents/AgentWorkspace.vue"),
    meta: {
      title: "Estructura de agentes ",
      requiresAuth: true,
    },
  },
  {
    path: "/cajas",
    name: "BoxesData",
    component: () => import("./views/Boxes/Boxes.vue"),
    meta: {
      title: "Listado de cajas ",
      requiresAuth: true,
    },
  },
  {
    path: "/apertura-y-cierre-de-caja",
    name: "ControlOfBoxes",
    component: () => import("./views/Boxes/ControlOfBoxes.vue"),
    meta: {
      title: "Apertura y cierre de caja ",
      requiresAuth: true,
    },
  },
  {
    path: "/dgii",
    name: "DGII",
    component: () => import("./views/DGII/DGII.vue"),
    meta: {
      title: "Actualizacion de datos DGII ",
      requiresAuth: true,
    },
  },
  {
    path: "/ventas",
    name: "SalesRoot",
    component: () => import("./views/Sales/Sales.vue"),
    meta: {
      title: "Ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/listado-de-ventas",
    name: "SalesList",
    component: () => import("./views/Sales/SalesList.vue"),
    meta: {
      title: "Listado de ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-ventas",
    name: "SalesReport",
    component: () => import("./views/Reports/Sales/General/SalesReport.vue"),
    meta: {
      title: "Reporte de ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/cotizaciones",
    name: "Quotes",
    component: () => import("./views/Quotes/Quotes.vue"),
    meta: {
      title: "Cotizaciones ",
      requiresAuth: true,
    },
  },
  {
    path: "/taller",
    name: "Workshop",
    component: () => import("./views/Workshop/Workshop.vue"),
    meta: {
      title: "Recepción de equipos ",
      requiresAuth: true,
    },
  },
  {
    path: "/taller/historial",
    name: "WorkshopHistory",
    component: () => import("./views/Workshop/Workshop.vue"),
    meta: {
      title: "Historial de equipos ",
      requiresAuth: true,
    },
  },
  {
    path: "/taller/listado",
    name: "WorkshopList",
    component: () => import("./views/Workshop/Workshop.vue"),
    meta: {
      title: "Listado de equipos ",
      requiresAuth: true,
    },
  },
  {
    path: "/ventas-temporales",
    name: "TemporarySales",
    component: () => import("./views/TemporarySales/TemporarySales.vue"),
    meta: {
      title: "Ventas temporales ",
      requiresAuth: true,
    },
  },
  {
    path: "/pedidos",
    name: "CustomerOrder",
    component: () => import("./views/CustomerOrder/CustomerOrder.vue"),
    meta: {
      title: "Pedidos - Factura HOLD ",
      requiresAuth: true,
    },
  },
  {
    path: "/cuentas-por-cobrar",
    name: "AccountsReceivable",
    component: () => import("./views/Sales/AccountsReceivable/AccountsReceivable.vue"),
    meta: {
      title: "Cuentas por cobrar ",
      requiresAuth: true,
    },
  },
  {
    path: "/historial-de-pagos-cuentas-por-crobrar",
    name: "ListOfAccountsReceivablePayments",
    component: () => import("./views/Sales/AccountsReceivable/ListOfAccountsReceivablePayments.vue"),
    meta: {
      title: "Historial de cuentas por cobrar ",
      requiresAuth: true,
    },
  },
  {
    path: "/cuentas-por-crobrar-aseguradoras",
    name: "InsuranceAccountsReceivable",
    component: () => import("./views/Sales/InsuranceAccountsReceivable/InsuranceAccountsReceivable.vue"),
    meta: {
      title: "Cuentas por cobrar aseguradoras ",
      requiresAuth: true,
    },
  },
  {
    path: "/historial-de-pagos-cuentas-por-crobrar-aseguradoras",
    name: "ListOfInsuranceAccountsReceivable",
    component: () => import("./views/Sales/InsuranceAccountsReceivable/ListOfInsuranceAccountsReceivable.vue"),
    meta: {
      title: "Historial de cuentas por cobrar aseguradoras ",
      requiresAuth: true,
    },
  },
  {
    path: "/notas-de-credito-ventas",
    name: "CreditNote",
    component: () => import("./views/Sales/CreditNote/CreditNote.vue"),
    meta: {
      title: "Notas de crédito ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-ganancias-y-utilidades-de-ventas",
    name: "ReportProfits",
    component: () => import("./views/Reports/Sales/ReportProfits/ReportProfits.vue"),
    meta: {
      title: "Reporte de ventas, Ganancias y venta total ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-ofertas",
    name: "PromotionOffersReport",
    component: () => import("./views/Reports/Sales/PromotionOffers/PromotionOffersReport.vue"),
    meta: {
      title: "Reporte de ofertas ",
      requiresAuth: true,
    },
  },
  {
    path: "/actividad-de-usuarios",
    name: "UsersActivityReport",
    component: () => import("./views/Reports/UsersActivity/UsersActivityReport.vue"),
    meta: {
      title: "Actividad de usuarios ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-productos",
    name: "ReportProducts",
    component: () => import("./views/Reports/Products/ReportProducts.vue"),
    meta: {
      title: "Reporte de productos ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-para-dgii",
    name: "ReportDGII",
    component: () => import("./views/Reports/Sales/DGII/ReportDGII/ReportDGII.vue"),
    meta: {
      title: "Declaración de impuestos ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-dgii-606",
    name: "ReportDGII606",
    component: () => import("./views/Reports/Sales/DGII/ReportDGII/ReportDGII.vue"),
    meta: {
      title: "Reporte DGII 606 ",
      requiresAuth: true,
    },
  },
  {
    path: "/estado-de-resultados",
    name: "IncomeStatement",
    component: () => import("./views/Accounting/IncomeStatement.vue"),
    meta: {
      title: "Estado de Resultados ",
      requiresAuth: true,
    },
  },
  {
    path: "/carta-de-retencion",
    name: "WithholdingLetter",
    component: () => import("./views/Accounting/WithholdingLetter.vue"),
    meta: {
      title: "Carta de Retencion ",
      requiresAuth: true,
    },
  },
  {
    path: "/productos-sin-movimiento",
    name: "InactiveProducts",
    component: () => import("./views/Reports/Products/InactiveProducts.vue"),
    meta: {title: "Productos sin movimiento ", requiresAuth: true},
  },
  {
    path: "/reporte-de-productos-mas-y-menos-vendidos",
    name: "BestSellingAndLessSold",
    component: () => import("./views/Reports/Products/BestSellingAndLessSold.vue"),
    meta: {
      title: "Productos con mas y menos movimiento ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-de-movimiento-de-productos-por-modulo",
    name: "ProductsAccordingToModuleEntered",
    component: () => import("./views/Reports/Products/ProductsAccordingToModuleEntered.vue"),
    meta: {
      title: "Movimiento de productos por módulo ",
      requiresAuth: true,
    },
  },
  {
    path: "/movimiento-de-productos",
    name: "ProductMovement",
    component: () => import("./views/Reports/Products/ProductMovement.vue"),
    meta: {
      title: "Movimiento de productos ",
      requiresAuth: true,
    },
  },
  {
    path: "/vendedor-del-mes",
    name: "SellerOfTheMonth",
    component: () => import("./views/Reports/SellerOfTheMonth/SellerOfTheMonth.vue"),
    meta: {
      title: "Vendedores del mes ",
      requiresAuth: true,
    },
  },
  {
    path: "/comparar-precio-entre-proveedores",
    name: "ComparePriceBetweenProviders",
    component: () => import("./views/Reports/ComparePriceBetweenProviders/ComparePriceBetweenProviders.vue"),
    meta: {
      title: "Comparar precio entre proveedores ",
      requiresAuth: true,
    },
  },
  {
    path: "/modulo-de-verificacion-de-productos-por-proveedor",
    name: "ProductsBySupplier",
    component: () => import("./views/Reports/ProductsBySupplier/ProductsBySupplier.vue"),
    meta: {
      title: "Seguimiento de productos segun compra y proveedor",
      requiresAuth: true,
    },
  },
  {
    path: "/productos-con-stock-minimo",
    name: "ProductsWithMinimumStock",
    component: () => import("./views/Reports/ProductsWithMinimumStock/ProductsWithMinimumStock.vue"),
    meta: {
      title: "Listado de productos segun stock minimo ",
      requiresAuth: true,
    },
  },
  {
    path: "/seguimiento-de-productos",
    name: "ProductTraking",
    component: () => import("./views/Reports/ProductTraking/ProductTraking.vue"),
    meta: {
      title: "Seguimiento de productos segun venta ",
      requiresAuth: true,
    },
  },
  {
    path: "/prestamos-del-personal",
    name: "StaffLoans",
    component: () => import("./views/Users/StaffLoans/StaffLoans.vue"),
    meta: {
      title: "Prestamos del personal ",
      requiresAuth: true,
    },
  },
  {
    path: "/marcar-asistencias",
    name: "UserAssists",
    component: () => import("./views/Users/UserAssists/UserAssists.vue"),
    meta: {
      title: "Marcar asistencias ",
      requiresAuth: true,
    },
  },
  {
    path: "/listado-de-asistencias",
    name: "ListUserAssists",
    component: () => import("./views/Users/UserAssists/ListUserAssists.vue"),
    meta: {
      title: "Listado de asistencias ",
      requiresAuth: true,
    },
  },
  {
    path: "/pagos-del-personal",
    name: "PersonalPayment",
    component: () => import("./views/Users/PersonalPayment/PersonalPayment.vue"),
    meta: {
      title: "Pagos del personal ",
      requiresAuth: true,
    },
  },
  {
    path: "/gastos",
    name: "Expenses",
    component: () => import("./views/Expenses/Expenses.vue"),
    meta: { title: "Gastos ", requiresAuth: true },
  },
  {
    path: "/tipos-de-gasto",
    name: "ExpenseTypes",
    component: () => import("./views/Expenses/ExpenseTypes.vue"),
    meta: { title: "Tipos de gasto ", requiresAuth: true },
  },
  {
    path: "/pagos-de-servicio",
    redirect: "/gastos",
    name: "ServicesDGII",
    component: () => import("./views/ServicesDGII/ServicesDGII.vue"),
    meta: {
      title: "Pago de servicio ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-consolidado",
    name: "ConsolidatedSales",
    component: () => import("./views/Reports/ConsolidatedSales/ConsolidatedSales.vue"),
    meta: {
      title: "Consolidado de reportes ",
      requiresAuth: true,
    },
  },
  {
    path: "/guia-de-remision-ventas",
    name: "SalesReferralGuide",
    component: () => import("./views/ReferralGuide/SalesReferralGuide.vue"),
    meta: {
      title: "Guia de remision ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/inventario-fisico",
    name: "PhysicalInventory",
    component: () => import("./views/Reports/Products/PhysicalInventory.vue"),
    meta: {
      title: "Inventario físico ",
      requiresAuth: true,
    },
  },
  {
    path: "/inventario-por-ubicacion",
    name: "InventoryLocation",
    component: () => import("./views/Inventory/InventoryLocation.vue"),
    meta: {
      title: "Inventario por ubicacion ",
      requiresAuth: true,
    },
  },
  {
    path: "/transferencias-inventario",
    name: "StockTransfersView",
    component: () => import("./views/Inventory/StockTransfersView.vue"),
    meta: {
      title: "Traslado interno ",
      requiresAuth: true,
    },
  },
  {
    path: "/despacho",
    name: "DispatchView",
    component: () => import("./views/Inventory/DispatchView.vue"),
    meta: {
      title: "Despacho ",
      requiresAuth: true,
    },
  },
  {
    path: "/cumplimiento-ventas",
    name: "SalesFulfillmentView",
    component: () => import("./views/Sales/Fulfillment/SalesFulfillmentView.vue"),
    meta: {
      title: "Listado de ordenes ",
      requiresAuth: true,
    },
  },
  {
    path: "/produccion",
    name: "ProductionOrdersView",
    component: () => import("./views/Production/ProductionOrdersView.vue"),
    meta: {
      title: "Ordenes de produccion ",
      requiresAuth: true,
    },
  },
  {
    path: "/produccion/listado",
    name: "ProductionHistoryView",
    component: () => import("./views/Production/ProductionHistoryView.vue"),
    meta: {
      title: "Listado de produccion ",
      requiresAuth: true,
    },
  },
  {
    path: "/disponibilidad-produccion",
    name: "ProductionAvailabilityView",
    component: () => import("./views/Production/ProductionAvailabilityView.vue"),
    meta: {
      title: "Disponibilidad en produccion ",
      requiresAuth: true,
    },
  },
  {
    path: "/repartidor",
    name: "MainDeliveryMan",
    component: () => import("./views/DeliveryMan/MainDeliveryMan.vue"),
    meta: {
      title: "Repartidor ",
      requiresAuth: true,
    },
  },
  {
    path: "/reporte-diario-de-ventas-detallado",
    name: "MainDailyReport",
    component: () => import("./views/Reports/Sales/DailyReport/MainDailyReport.vue"),
    meta: {
      title: "Reporte detallado de ventas ",
      requiresAuth: true,
    },
  },
  {
    path: "/traslado-interno",
    redirect: "/transferencias-inventario",
  },
  {
    path: "/listado-traslado-interno",
    redirect: "/transferencias-inventario",
  },
  {
    path: "/log-notas-de-credito",
    name: "CreditLotesLogView",
    component: () => import("./views/logs/CreditLotesLogView.vue"),
    meta: {
      title: "Log Notas de crédito ",
      requiresAuth: true,
    },
  },
  {
    path: "/lista-de-precio-productos",
    name: "ProductPriceListView",
    component: () => import("./views/Reports/Products/ProductPriceListView.vue"),
    meta: {
      title: "Lista de precios",
      requiresAuth: false,
    },
  },
  {
    path: "/reporte-de-venta-diaria-por-clientes",
    name: "MainDailyReportByClient",
    component: () => import("./views/Reports/Sales/DailyReport/MainDailyReportByClient.vue"),
    meta: {
      title: "Reporte venta diaria por cliente",
      requiresAuth: false,
    },
  },
  {
    path: "/configuracion-whatsapp",
    name: "WhatsAppConfiguration",
    component: () => import("./views/WhatsAppConfiguration.vue"),
    meta: {
      title: "Configuración WhatsApp",
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const storedAccess = localStorage.getItem("access");
  const loggedIn = hasValidSession();
  const trackingSlug = String(to.query?.tracking || "").trim();
  const businessSlug = String(to.query?.business || "").trim();

  if (storedAccess && !loggedIn) {
    clearStoredSession();
  }

  if (to.path === "/" && trackingSlug) {
    next({
      path: `/seguimiento/${businessSlug || "negocio"}/${trackingSlug}`,
      replace: true,
    });
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!loggedIn) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.name === "login") && loggedIn) {
    next("/");
  } else {
    next();
  }
});

export default router;
